import { useLocation } from "react-router-dom";
import DynamicNotification from "../DynamicNotification/Index";
import { useEffect, useState } from "react";
import JobDescriptionService from "../../Services/job-description.service";
import useExpiry from "../../Hooks/useExpiry";
import { JobDescription } from "../../Entities/job-description.entity";

const AppAgent = () => {
  const location = useLocation();
  const [jobPosts, setJobPosts] = useState<JobDescription[]>([]);
  const { isBasePlanExpired } = useExpiry();

  const knownPaths = ["/", "/questionnaire", "/preliminary-match"];

  const isInterviewRoundPage = /^\/([a-zA-Z0-9]+)?\/interview-round/.test(
    location.pathname
  );
  const isRequirementsPage = /^\/([a-zA-Z0-9]+)?\/requirements/.test(
    location.pathname
  );
  const isOnlineInterviewPage = /^\/([a-zA-Z0-9]+)?\/online-interview/.test(
    location.pathname
  );

  const isResultPage = /^\/([a-zA-Z0-9]+)?\/result/.test(location.pathname);

  const isAuthPage = [
    "/sign-in",
    "/sign-up",
    "/forgot-password",
    "/reset-password",
  ].includes(location.pathname);

  useEffect(() => {
    fetchJobPosts();
  }, []);
  const fetchJobPosts = async () => {
    try {
      const data = await JobDescriptionService.getInstance().findAllJobPostWithFiletrsAndPositionCounts({
        page: 1,
        limit: 10,
        position: [],
        searchQuery: null,
      });

      if (!data || !data.jobPosts) {
        console.error("Invalid response format from job posts API");
        return;
      }

      setJobPosts(data.jobPosts);
    } catch (error) {
      console.error("Error fetching job positions:", error);
      setJobPosts([]);
    }
  };

  const shouldShowNotification =
    (knownPaths.includes(location.pathname) ||
      isInterviewRoundPage ||
      isRequirementsPage ||
      isOnlineInterviewPage ||
      isResultPage) &&
    !isAuthPage &&
    jobPosts.length > 0 &&
    !isBasePlanExpired;

  if (shouldShowNotification) {
    return <DynamicNotification key="dynamic-notification" />;
  }

  return null;
};

export default AppAgent;
